import { Fragment } from 'react'
import { useShopStores } from './use-store'
import { expressCheckoutComponentMaps } from '../utils/express-checkout-map'

export const useExpressCheckout = () => {
  const { experimentsStore, paymentStore } = useShopStores()
  const productIsFree = paymentStore.store?.free

  const expressCheckoutConfig = experimentsStore?.getDynamicConfig('express_checkout_config')
  const expressCheckoutMethods = (expressCheckoutConfig?.value.express_checkout as string[]) || []

  // Filter out methods that return null (not available) and render only available ones
  const availableExpressCheckoutComponents = expressCheckoutMethods
    .map((method, index) => {
      const component = expressCheckoutComponentMaps()[method]
      if (!component) return null

      const renderedComponent = component()
      return renderedComponent ? <Fragment key={index}>{renderedComponent}</Fragment> : null
    })
    .filter(Boolean)

  return {
    expressCheckoutMethods,
    availableExpressCheckoutComponents,
    hasAvailableExpressCheckout: availableExpressCheckoutComponents.length > 0 && !productIsFree,
  }
}
